// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__33_hR","load2":"Spinner_load2__AcxTe"};